// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
.customer-rating {
  flex-direction: column;
}
.customer-rating.show-animation app-star-solid-icon:nth-child(1) {
  animation: star-1 0.6s;
}
.customer-rating.show-animation app-star-solid-icon:nth-child(2) {
  animation: star-2 0.6s;
}
.customer-rating.show-animation app-star-solid-icon:nth-child(3) {
  animation: star-3 0.6s;
}
.customer-rating.show-animation app-star-solid-icon:nth-child(4) {
  animation: star-4 0.6s;
}
.customer-rating.show-animation app-star-solid-icon:nth-child(5) {
  animation: star-5 0.6s;
}

app-star-solid-icon, app-star-empty-icon {
  cursor: pointer;
}

@keyframes star-1 {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  35% {
    transform: scale(1);
  }
}
@keyframes star-2 {
  15% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(1);
  }
}
@keyframes star-3 {
  30% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  65% {
    transform: scale(1);
  }
}
@keyframes star-4 {
  45% {
    transform: scale(1);
  }
  65% {
    transform: scale(1.2);
  }
  80% {
    transform: scale(1);
  }
}
@keyframes star-5 {
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(1.2);
  }
  95% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/product/customer-rating/customer-rating.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,sBAAA;AADF;AAKI;EACE,sBAAA;AAHN;AAMI;EACE,sBAAA;AAJN;AAOI;EACE,sBAAA;AALN;AAQI;EACE,sBAAA;AANN;AASI;EACE,sBAAA;AAPN;;AAYA;EACE,eAAA;AATF;;AAYA;EACE;IACE,mBAAA;EATF;EAWA;IACE,qBAAA;EATF;EAWA;IACE,mBAAA;EATF;AACF;AAYA;EACE;IACE,mBAAA;EAVF;EAYA;IACE,qBAAA;EAVF;EAYA;IACE,mBAAA;EAVF;AACF;AAaA;EACE;IACE,mBAAA;EAXF;EAaA;IACE,qBAAA;EAXF;EAaA;IACE,mBAAA;EAXF;AACF;AAcA;EACE;IACE,mBAAA;EAZF;EAcA;IACE,qBAAA;EAZF;EAcA;IACE,mBAAA;EAZF;AACF;AAeA;EACE;IACE,mBAAA;EAbF;EAeA;IACE,qBAAA;EAbF;EAeA;IACE,mBAAA;EAbF;AACF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"../../../../../../variables\";\n@import \"../../../../../../../node_modules/bootstrap/scss/mixins/breakpoints\";\n\n.customer-rating {\n  flex-direction: column;\n\n  &.show-animation {\n\n    app-star-solid-icon:nth-child(1) {\n      animation: star-1 .6s;\n    }\n\n    app-star-solid-icon:nth-child(2) {\n      animation: star-2 .6s;\n    }\n\n    app-star-solid-icon:nth-child(3) {\n      animation: star-3 .6s;\n    }\n\n    app-star-solid-icon:nth-child(4) {\n      animation: star-4 .6s;\n    }\n\n    app-star-solid-icon:nth-child(5) {\n      animation: star-5 .6s;\n    }\n  }\n}\n\napp-star-solid-icon, app-star-empty-icon {\n  cursor: pointer;\n}\n\n@keyframes star-1 {\n  0% {\n    transform: scale(1);\n  }\n  20% {\n    transform: scale(1.2);\n  }\n  35% {\n    transform: scale(1);\n  }\n}\n\n@keyframes star-2 {\n  15% {\n    transform: scale(1);\n  }\n  35% {\n    transform: scale(1.2);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n\n@keyframes star-3 {\n  30% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  65% {\n    transform: scale(1);\n  }\n}\n\n@keyframes star-4 {\n  45% {\n    transform: scale(1);\n  }\n  65% {\n    transform: scale(1.2);\n  }\n  80% {\n    transform: scale(1);\n  }\n}\n\n@keyframes star-5 {\n  60% {\n    transform: scale(1);\n  }\n  80% {\n    transform: scale(1.2);\n  }\n  95% {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
